/**
 * Site header — mobile menu drawer.
 *
 * Opens via [data-menu-toggle], closes via [data-menu-close] or backdrop click.
 * Locks body scroll while open, traps focus inside the panel, and restores
 * focus to the toggle on close.
 */
(() => {
  const drawer = document.querySelector('[data-menu-drawer]');
  if (!drawer) return;

  const toggles = document.querySelectorAll('[data-menu-toggle]');
  const closers = drawer.querySelectorAll('[data-menu-close]');
  const panel = drawer.querySelector('[data-menu-panel]');
  if (!toggles.length || !panel) return;

  let lastFocus = null;

  const focusables = () =>
    panel.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

  const open = () => {
    lastFocus = document.activeElement;
    drawer.dataset.open = 'true';
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    toggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => {
      const first = focusables()[0];
      if (first) first.focus();
    });
  };

  const close = () => {
    drawer.dataset.open = 'false';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    toggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  };

  toggles.forEach((t) =>
    t.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.dataset.open === 'true' ? close() : open();
    })
  );
  closers.forEach((c) => c.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (drawer.dataset.open !== 'true') return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') {
      const items = Array.from(focusables());
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
